import { Str } from '../../localization/translationKeys';
import { COLORS } from '../../globalStyle/colors';
import { Map } from '../../language/models';
import { Routes } from '../../navigation/routes';
import { DevPlan, DevPlanAction } from './models';
import * as R from 'ramda';


export const ctaMsgForProgress = (plan: DevPlan | undefined): Str => 
  plan?.devPlanItemCount !== 0 || plan.devPlanEmailSent ? Str.ViewEdit : Str.Begin;

export const subtitleMsgForProgress = (plan: DevPlan | undefined): Str => {
  const progress = plan?.devPlanAmountComplete;
  const started = plan?.devPlanItemCount! > 0 || plan?.devPlanEmailSent;

  const noRequirements = plan?.developmentPlanEmailLevelId === 0 && plan?.developmentPlanGoalsToTrack === 0;

  if (!started) {
    return Str.ReviewFeedback;
  }

  if (!noRequirements && (progress === 1 || progress === 100) && started) {
    return Str.DevPlanCompleteMsg;
  }

  return Str.DashMakingProgressMsg;
};


export const requirementsMsgFor = (plan: DevPlan | undefined): Str | undefined => {
  if (!plan || plan.devPlanAmountComplete === 0) {
    return undefined;
  }

  return plan.developmentPlanEmailLevelId > 0 && plan.developmentPlanGoalsToTrack > 0
    ? Str.DashDevPlanItemsEmailMsg
    : plan.developmentPlanGoalsToTrack > 0
      ? Str.DashDevPlanItemsMsg
      : Str.DashDevPlanEmailMsg;
};

export const requirementsMsgSubstitutionsFor = (plan: DevPlan | undefined): { [key: string]: string; } => {
  if (!plan) {
    return {};
  }

  return {
    'number':    `${plan.developmentPlanGoalsToTrack}`,
    'levelName': plan.devPlanEmailLevelName,
  };
};


export const colorForProgress = (
  plan: DevPlan | undefined,
): string => {
  const noRequirements = plan?.developmentPlanEmailLevelId === 0 && plan?.developmentPlanGoalsToTrack === 0;
  const complete = plan?.devPlanAmountComplete === 1 || plan?.devPlanAmountComplete === 100;

  return !noRequirements && complete ? COLORS.BLUE : COLORS.GREEN;
}


export const routeForProgress = (
  plan: DevPlan | undefined,
  routes: Routes,
): string => {
  const started = plan?.devPlanItemCount !== 0 || plan.devPlanEmailSent;
  return started ? routes.DevPlan : routes.AddPlanItem
};


/**
 * Sums up the given actions, bucketed by dev item ID. Returns a mapping ItemId -> Action Total
 */
export const actionsByItemId = (
  actions: DevPlanAction[],
): Map<DevPlanAction[]> => actions.reduce(
  (running, next) => R.assoc(
    `${next.devItemId}`,
    (running[next.devItemId] ?? []).concat(next),
    running,
  ),
  {} as Map<DevPlanAction[]>,
);
